import React, { useState } from 'react';
import getFluidGatsbyImage from 'hooks/getFluidGatsbyImage';
import { WebsiteImage } from 'components/TitleDescription';
import SubscribeForm from 'components/Form/SubscribeForm';
import Button from 'components/Button';
import ModalMarketingForm from 'components/ModalMarketingForm';
import useIsImageColorDark from 'hooks/useIsImageColorDark';
import { ConversionPanelContainer, FormContainer } from './styles';

const RichTextConversionPanel = ({ fields, ...otherProps }) => {
  const [isModalOpen, toggleIsModalOpen] = useState(false);
  const { callToAction } = fields || {};
  const color =
    callToAction &&
    callToAction['en-US'][0].fields?.color &&
    callToAction['en-US'][0].fields?.color['en-US'];

  const icon = fields?.icon && fields?.icon['en-US'].fields?.image['en-US'].fields?.file['en-US'];

  const modalForm =
    callToAction &&
    callToAction['en-US'][0].fields?.modalForm &&
    callToAction['en-US'][0].fields?.modalForm['en-US'].fields;

  const useModalForm =
    callToAction &&
    callToAction['en-US'][0].fields?.useModalForm &&
    callToAction['en-US'][0].fields?.useModalForm['en-US'];

  const url = icon?.url;
  const contentType = icon?.contentType;
  const details = icon?.details;
  const fluidsrc = {
    fluid: getFluidGatsbyImage({ file: { contentType, url, details } }, { toFormat: 'webp' }),
  };

  const backgroundImg = fields?.backgroundImage?.['en-US']?.fields?.file?.['en-US']?.url;
  const { imageDark } = useIsImageColorDark(backgroundImg);
  const textColor = imageDark ? 'var(--white-color)' : 'var(--black-color)';

  const thankYouMessage =
    callToAction &&
    callToAction['en-US'][0]?.fields?.modalForm['en-US']?.fields?.thankyou &&
    callToAction['en-US'][0]?.fields?.modalForm['en-US']?.fields?.thankyou['en-US'];

  return (
    <ConversionPanelContainer {...otherProps} backgroundImg={backgroundImg} textColor={textColor}>
      <div className="blog-conversion-panel--main">
        {fluidsrc.fluid && <WebsiteImage className="blog-conversion-panel--photo" src={fluidsrc} />}
        <div className="blog-conversion-panel--content">
          {fields?.headline && (
            <p className="blog-conversion-panel--heading">{fields?.headline['en-US']}</p>
          )}
          {fields?.subhead && <p>{fields?.subhead['en-US']?.content[0]?.content[0]?.value}</p>}
        </div>
      </div>
      {!useModalForm ? (
        <FormContainer>
          <SubscribeForm
            dataPosition="Conversion Panel"
            formType="Email Capture"
            marketoForm={modalForm?.marketoForm['en-US']}
            buttonType="primary"
            notificationMessage={thankYouMessage ? thankYouMessage : 'Thanks for subscribing!'}
            notificationSnack={true}
            shouldRedirect={false}
            shadow={false}
            label=""
          />
        </FormContainer>
      ) : (
        <div className="blog-conversion-panel--button">
          <Button
            {...(useModalForm ? { onClick: () => toggleIsModalOpen(true) } : {})}
            width={'100%'}
            to={
              callToAction['en-US'][0].fields?.url && callToAction['en-US'][0].fields?.url['en-US']
            }
            dataPosition="Blog Detail Embedded CTA"
            shadow={false}
            type={
              color === 'Orange'
                ? 'primary'
                : color === 'Blue'
                ? 'secondary'
                : color === 'Black'
                ? 'tertiary'
                : color === 'White'
                ? 'white'
                : 'secondary'
            }
            height={'55px'}
            {...(useModalForm ? { onClick: () => toggleIsModalOpen(true) } : {})}
          >
            {callToAction['en-US'][0].fields?.buttonLabel['en-US']}
          </Button>
        </div>
      )}
      {modalForm ? (
        <ModalMarketingForm
          dataPosition="Conversion Panel"
          isModalOpen={isModalOpen}
          onModalCancel={() => toggleIsModalOpen(false)}
          marketingForm={modalForm.marketoForm['en-US']}
          onFormSuccess={() => toggleIsModalOpen(false)}
        />
      ) : null}
    </ConversionPanelContainer>
  );
};

export default RichTextConversionPanel;
